import { api } from '../configs/axiosConfigs';

export const getListSorts = async () => {
  return await api.get('/list-sorts.json');
};
